import { render, staticRenderFns } from "./AdditionalSlide.vue?vue&type=template&id=de2f2d52"
import script from "./AdditionalSlide.vue?vue&type=script&lang=js"
export * from "./AdditionalSlide.vue?vue&type=script&lang=js"
import style0 from "./AdditionalSlide.vue?vue&type=style&index=0&id=de2f2d52&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports